module.exports = function getResource(label, vars = []) {
    let resources = {
        chooseRegion: 'Choisir une région :'
    };

    return resources[label];
};
